import React, {Component} from 'react';
import {Grid, Row, Col, ControlLabel, ButtonToolbar} from "react-bootstrap";
import {TopButtonAction, TopButtonAdd, TopButtonPointEdit} from "../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import Select from 'react-select'
import FirmyService from "../../../klienciConfig/firmy/FirmyService";
import FirmyForm from "../../../klienciConfig/firmy/components/FirmyForm";
import CurrencyInput from "react-money-input";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";

export default class PopupDaneDoFaktury extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wynajem: null,
            kwota:0,
            formaPlatnosci: {value: 'GK', label: 'GOTÓWKA'},
            formyPlatnosci: [{value: 'GK', label: 'GOTÓWKA'}, {value: 'PR', label: 'PRZELEW'}],
            pokazFormularzDodawaniaEdycjiFirmy: false,
            firmaDoFaktury: null,
        };
        this.onChangeFirmaDoFaktury = this.onChangeFirmaDoFaktury.bind(this)
        this.onChangeKwota = this.onChangeKwota.bind(this)
        this.onChangeFormaPlatnosci = this.onChangeFormaPlatnosci.bind(this)
        this.onClickZapiszFirme = this.onClickZapiszFirme.bind(this)
    }

    componentDidMount() {
        this.setState({wynajem: this.props.obiektDoFaktury, kwota: this.props.obiektDoFaktury.cenaNajmu})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({wynajem: nextprops.obiektDoFaktury, kwota: nextprops.obiektDoFaktury.cenaNajmu})
    }

    onChangeFirmaDoFaktury(e) {
        this.setState({
            firmaDoFaktury: e
        })
    }

    renderFirmaOption(option) {
        return (<div><span className={'label label-ebus-primary'} title={'NIP'}>{option.nip}</span> {option.nazwa}
            { option.idNabywcy?
            <span style={{color: 'grey', fontSize: '12px', marginLeft: '15px'}}><i className={'fa fa-info-circle'}></i> Tylko odbiorca!</span> : ''}
        </div>)
    }

    getCompanies(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return FirmyService.szukajFirmePoNipieAlboPoNazwie(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    informacje: item.nip + ' ' + item.nazwa,
                }
            })
            return {options: arr}
        }.bind(this))
    }

    onClickZapiszFirme(obj, czyEdycja) {
        if (czyEdycja) {
            FirmyService.editFirma(this.state.firmaDoFaktury.idFi, obj).then(function (response) {

                let obiekt = this.state.firmaDoFaktury
                obiekt['nazwa'] = obj.nazwa
                obiekt['kodPocztowy'] = obj.kodPocztowy
                obiekt['regon'] = obj.regon
                obiekt['miejscowosc'] = obj.miejscowosc
                obiekt['nrLokalu'] = obj.nrLokalu
                obiekt['nrNieruchomosci'] = obj.nrNieruchomosci
                obiekt['ulica'] = obj.ulica
                obiekt['wojewodztwo'] = obj.wojewodztwo
                obiekt['informacje'] = obj.nip + ' ' + obj.nazwa

                this.setState({
                    firmaDoFaktury: obiekt,
                    pokazFormularzDodawaniaEdycjiFirmy: false
                })

            }.bind(this))
        }
        else {
            FirmyService.addFirma(obj).then(function (response) {
                if (response) {
                    if (response.data) {
                        this.setState({
                            firmaDoFaktury: Object.assign(response.data, {informacje: response.data.nip + ' ' + response.data.nazwa}),
                            pokazFormularzDodawaniaEdycjiFirmy: false
                        })
                    }
                }
            }.bind(this))

        }
    }

    onClickWystaw(czyWydrukowac) {
        console.log(this.state.firmaDoFaktury, 'czyWydrukowac: ' + czyWydrukowac)
    }

    onChangeKwota(e, maskedvalue, floatvalue) {
        this.setState({kwota: maskedvalue})
    }

    onChangeFormaPlatnosci(e){
        this.setState({formaPlatnosci:e})
    }

    render() {

        return (

            <div id={'EBUSModalContainerBG'}>
                <div id={'modalContainer'} className={'modalFaktura'}>
                    <div>
                        <div className={'pull-right'}>
                            <TopButtonAction onClick={() => {
                                this.props.handleClickZamknij()
                            }}
                                             elementStyle={{color:'firebrick'}}
                                             btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                            />
                        </div>
                    </div>
                    <div style={{clear: 'both'}}></div>
                    {
                        Boolean(this.state.wynajem) ?
                            <div id={'modalTextContent'}>
                                <h4>
                                    Wystaw fakturę VAT dla wynajmu o tytule {this.state.wynajem.tytul}
                                </h4>
                                <div style={{marginTop:'15px', marginBottom:'5px'}}>
                                    <Row>
                                        <Col xs={6}>
                                            <ControlLabel>Kwota: <span className={'req'}>*</span></ControlLabel>
                                            <CurrencyInput decimalSeparator="," thousandSeparator="." className="form-control" suffix=" zł"
                                                           onChange={this.onChangeKwota}
                                                           value={this.state.kwota}/>
                                        </Col>
                                        <Col xs={6}>
                                            <ControlLabel>Forma płatności: <span className={'req'}>*</span></ControlLabel>
                                            <TopSelect onChange={this.onChangeFormaPlatnosci}
                                                       value={this.state.formaPlatnosci}
                                                       options={this.state.formyPlatnosci}
                                                       clearable={false}/>
                                        </Col>
                                    </Row>
                                </div>
                                <div>
                                    <ControlLabel>Wyszukaj firmę bądź dodaj nową: <span className={'req'}>*</span></ControlLabel>
                                    <Select.Async value={this.state.firmaDoFaktury} onChange={this.onChangeFirmaDoFaktury}
                                                  valueKey="idFi"
                                                  labelKey="informacje" loadOptions={this.getCompanies} clearable={false}
                                                  backspaceRemoves={true}
                                                  placeholder={'Wyszukaj firmę po NIP lub po nazwie'}

                                                  valueRenderer={(option) => this.renderFirmaOption(option)}
                                                  optionRenderer={(option) => this.renderFirmaOption(option)}
                                                  ignoreAccents={false}
                                                  noResultsText={<div>Brak wyników <TopButtonAdd
                                                      onClick={() => this.setState({pokazFormularzDodawaniaEdycjiFirmy: true})}
                                                      text={'Dodaj nową firmę'} buttonSize={'small'}/></div>}
                                    />
                                </div>
                                <div style={{marginTop: '5px', marginBottom: '15px'}}>
                                    {
                                        Boolean(this.state.pokazFormularzDodawaniaEdycjiFirmy) ?
                                            <div>
                                                <FirmyForm
                                                    edytowanaFirma={this.state.firmaDoFaktury}
                                                    czyMoznaEdytowacNip={!(Boolean(this.state.firmaDoFaktury))}
                                                    handleClickAnuluj={() => {
                                                        this.setState({pokazFormularzDodawaniaEdycjiFirmy: false})
                                                    }}
                                                    handleClickZapisz={this.onClickZapiszFirme}
                                                    widokNaPopup={true}
                                                />
                                                <div style={{clear: 'both'}}></div>
                                            </div>
                                            :

                                            <div>
                                                {
                                                    (Boolean(this.state.firmaDoFaktury)) ?
                                                        <div>
                                                            <div className={'thumbnail'} style={{padding: '15px'}}>
                                                                <h4 style={{marginBottom: '5px'}}>Firma, na którą zostanie wystawiona
                                                                    faktura:</h4>
                                                                <div>
                                                                    <Row>
                                                                        <Col xs={5}>
                                                                            <h5 style={{color: 'grey', fontStyle: 'italic'}}>Dane
                                                                                podstawowe</h5>
                                                                            <div>
                                                                                <label>Nazwa:</label> {this.state.firmaDoFaktury.nazwa}
                                                                            </div>
                                                                            <div><label>NIP:</label> {this.state.firmaDoFaktury.nip}
                                                                            </div>
                                                                            {
                                                                                Boolean(this.state.firmaDoFaktury.regon) ?
                                                                                    <div>
                                                                                        <label>REGON:</label> {this.state.firmaDoFaktury.regon}
                                                                                    </div>
                                                                                    :
                                                                                    ''
                                                                            }
                                                                        </Col>
                                                                        <Col xs={5}>
                                                                            <h5 style={{
                                                                                color: 'grey',
                                                                                fontStyle: 'italic'
                                                                            }}>Adres</h5>
                                                                            <div>
                                                                                {Boolean(this.state.firmaDoFaktury.ulica) ? this.state.firmaDoFaktury.ulica : ''} {Boolean(this.state.firmaDoFaktury.nrNieruchomosci) ? this.state.firmaDoFaktury.nrNieruchomosci : ''}{Boolean(this.state.firmaDoFaktury.nrLokalu) ? '/' + this.state.firmaDoFaktury.nrLokalu : ''}
                                                                            </div>
                                                                            <div>
                                                                                {Boolean(this.state.firmaDoFaktury.kodPocztowy) ? this.state.firmaDoFaktury.kodPocztowy : ''} {this.state.firmaDoFaktury.miejscowosc}{Boolean(this.state.firmaDoFaktury.wojewodztwo) ? ', ' + this.state.firmaDoFaktury.wojewodztwo : ''}
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={2}>
                                                                            <TopButtonPointEdit
                                                                                onClick={() => this.setState({pokazFormularzDodawaniaEdycjiFirmy: true})}
                                                                                titleContent={'Edytuj dane firmy'}/>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        ''
                                                }
                                            </div>
                                    }
                                </div>
                                <div>
                                    <TopIf isTrue={Boolean(this.state.firmaDoFaktury) && !this.state.pokazFormularzDodawaniaEdycjiFirmy}>
                                        <div className={'pull-right'}>
                                            <ButtonToolbar>
                                                <TopButtonAction iconType={'fa fa-print'} text={'Wystaw i wydrukuj fakturę'} btnColor={'info'}
                                                                 onClick={() => this.onClickWystaw(true)}/>
                                                <TopButtonAction iconType={'fa fa-text-file-o'} text={'Wystaw fakturę'} btnColor={'success'}
                                                                 onClick={() => this.onClickWystaw(false)}/>
                                            </ButtonToolbar>
                                        </div>
                                        <div style={{clear: 'both'}}></div>
                                    </TopIf>
                                </div>
                            </div>
                            :
                            <div id={'modalTextContent'}>
                                <TopAlertUwaga text={'Nie udało się załadować danych wynajmu'}/>
                            </div>
                    }

                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/popupDaneDoFaktury/PopupDaneDoFaktury.js